// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"73eabf8b","258":"a40aac83","268":"6b092188","453":"424bf6a0","457":"aef128e0","551":"2f28fea7","624":"c05cb507","842":"af87e88a","848":"09bbc8c5"}[chunkId] + ".chunk.js";
};